// src/sectors/pilates/sessions/data/mockCalendarData.js

function pad2(n) {
  return String(n).padStart(2, '0');
}

export function isoToday() {
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function startOfWeekISO(iso) {
  const d = new Date(iso + 'T00:00:00');
  const dow = (d.getDay() + 6) % 7; // Monday=0
  d.setDate(d.getDate() - dow);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function addDaysISO(iso, days) {
  const d = new Date(iso + 'T00:00:00');
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export const DAY_LABELS = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts', 'Paz'];

export const TRAINERS = [
  { id: 't1', name: 'Elif', color: '#7B61FF' },
  { id: 't2', name: 'Burcu', color: '#00A3A3' },
  { id: 't3', name: 'Seda', color: '#FF5C8A' },
];

// NORMAL(mavi) | TELAFI(sarı)
// attended: null(işaretlenmedi) | true(geldi) | false(gelmedi)
export function mockSessions(weekStartISO) {
  return [
    // Pazartesi 10:00 aynı slotta 2 seans (ALL görünümünde yan yana)
    {
      id: 's1',
      dayISO: addDaysISO(weekStartISO, 0),
      startMin: 10 * 60,
      dur: 60,
      type: 'NORMAL',
      attended: null,
      title: 'Grup • Reformer',
      trainerId: 't1',
      cap: 8,
      booked: 6,
      members: ['Kerem Turak', 'Arif Erdem', 'Mehmet Avcı'], // 3 kişi
    },
    {
      id: 's2',
      dayISO: addDaysISO(weekStartISO, 0),
      startMin: 10 * 60,
      dur: 60,
      type: 'TELAFI',
      attended: true,
      title: 'Private',
      trainerId: 't2',
      cap: 1,
      booked: 1,
      members: ['Özge Özerli'], // 1 kişi
    },

    // Pazartesi 12:00
    {
      id: 's3',
      dayISO: addDaysISO(weekStartISO, 0),
      startMin: 12 * 60,
      dur: 60,
      type: 'NORMAL',
      attended: false,
      title: 'Grup • Mat',
      trainerId: 't3',
      cap: 10,
      booked: 8,
      members: ['Deniz', 'Ayşe'], // 2 kişi
    },

    // Çarşamba 18:00
    {
      id: 's4',
      dayISO: addDaysISO(weekStartISO, 2),
      startMin: 18 * 60,
      dur: 60,
      type: 'NORMAL',
      attended: true,
      title: 'Grup • Reformer',
      trainerId: 't2',
      cap: 12,
      booked: 10,
      members: ['Mert', 'Can', 'Selin'], // 3 kişi
    },

    // Cuma 09:00
    {
      id: 's5',
      dayISO: addDaysISO(weekStartISO, 4),
      startMin: 9 * 60,
      dur: 60,
      type: 'NORMAL',
      attended: null,
      title: 'Private',
      trainerId: 't1',
      cap: 1,
      booked: 0,
      members: [],
    },

    // Cumartesi 11:00
    {
      id: 's6',
      dayISO: addDaysISO(weekStartISO, 5),
      startMin: 11 * 60,
      dur: 60,
      type: 'TELAFI',
      attended: true,
      title: 'Grup • Mat',
      trainerId: 't3',
      cap: 10,
      booked: 10,
      members: ['Ece', 'Zeynep', 'Bora'], // 3 kişi
    },

    // Pazar 19:00 aynı slotta 2 seans
    {
      id: 's7',
      dayISO: addDaysISO(weekStartISO, 6),
      startMin: 19 * 60,
      dur: 60,
      type: 'NORMAL',
      attended: null,
      title: 'Grup • Reformer',
      trainerId: 't1',
      cap: 8,
      booked: 7,
      members: ['Sinem', 'Okan'], // 2 kişi
    },
    {
      id: 's8',
      dayISO: addDaysISO(weekStartISO, 6),
      startMin: 19 * 60,
      dur: 60,
      type: 'TELAFI',
      attended: false,
      title: 'Private',
      trainerId: 't2',
      cap: 1,
      booked: 1,
      members: ['Barış Y.'],
    },
  ];
}
